<template>
    <div>
        <div :id="idChart" ref="chartContainer" v-if="!noData"></div>
        <NoData v-else></NoData>
    </div>
</template>

<script>
import moment from 'moment';
import Highcharts from "highcharts";
import HighChartsMore from 'highcharts/highcharts-more';
import Accessibility from 'highcharts/modules/accessibility';
import Exporting from 'highcharts/modules/export-data';
import NoData from '@/components/common/NoData.vue';
Accessibility(Highcharts);
Exporting(Highcharts);
HighChartsMore(Highcharts);
export default {
    name: 'UsefulVolumeChart',
    props:['basin', 'periodDate', 'volumeData', 'unitMeasurement', 'idChart'],
    data:()=>({
        chartRendered: undefined,
        showLabels: true,
        noData: false,
    }),
    components: {
        NoData
    },
    computed:{
        operationalMaxQuote(){
            return this.basin && this.basin.COTA_MAXIMA_OPERACIONAL ? this.basin.COTA_MAXIMA_OPERACIONAL : undefined;
        },
        operationalMinQuote(){
            return this.basin && this.basin.COTA_MINIMA_OPERACIONAL ? this.basin.COTA_MINIMA_OPERACIONAL : undefined;
        },
        activeThresholdsList() {
        const STATUS_COLORS = {
            NORMAL: '#aced93',
            YELLOW: 'rgb(229, 211, 18)',
            ORANGE: 'rgb(234, 157, 2)',
            RED:    'rgb(182, 11, 229)'
        };

        const percentThresholds = [
            { val: 100, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 80% e 100%" },
            { val: 80,  col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc: "Volume entre 70% e 79%" },
            { val: 70,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc: "Volume entre 55% e 69%" },
            { val: 55,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 55%" }
        ];

        const hectometerThresholdsConfig = {
            'SAIC' : [
                {val: 170, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 134,624 hm³ e 170 hm³" },
                {val: 134.624, col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc: "Volume entre 117,796 hm³ e 134,624 hm³"},
                {val: 117.796,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc: "Volume entre 92,554 hm³ e 117,796 hm³"},
                {val: 92.554,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 92,554 hm³" }
            ],
            'Iraí': [
                {val: 42, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 33,25 hm³ e 42 hm³"},
                {val: 33.25, col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc:"Volume entre 29,09 hm³ e 33,25 hm³"},
                {val: 29.09,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc:"Volume entre 22,86 hm³ e 29,09 hm³"},
                {val: 22.86,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 22,86 hm³" }
            ],
            'Passaúna': [
                {val: 70, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 55,60 hm³ e 70 hm³"},
                {val: 55.60, col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc:"Volume entre 48,65 hm³ e 55,60 hm³"},
                {val: 48.65,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc:"Volume entre 38,23 hm³ e 48.65 hm³"},
                {val: 38.23,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 38,23 hm³" }
            ],
            'Piraquara I': [
                {val: 34, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 26,46 hm³ e 34 hm³"},
                {val: 26.46, col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc:"Volume entre 23,16 hm³ e 26,46 hm³"},
                {val: 23.16,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc:"Volume entre 18,19 hm³ e 23,16 hm³"},
                {val: 18.19,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 18,19 hm³" }
            ],
            'Piraquara II': [
                {val: 24, col: STATUS_COLORS.NORMAL, text: "Normal", desc: "Volume entre 19,31 hm³ e 24 hm³"},
                {val: 19.31, col: STATUS_COLORS.YELLOW, text: "Alerta amarelo", desc:"Volume entre 16,90 hm³ e 19,31 hm³"},
                {val: 16.9,  col: STATUS_COLORS.ORANGE, text: "Alerta laranja", desc:"Volume entre 13,28 hm³ e 16,90 hm³"},
                {val: 13.28,  col: STATUS_COLORS.RED, text: "Alerta Vermelho", desc: "Volume menor que 13,28 hm³" }
            ]
        };

        const currentHectometerThresholds = hectometerThresholdsConfig[this.basin.text] || [];
        return (this.unitMeasurement === '%') ? percentThresholds : currentHectometerThresholds;
      }
    },
    methods:{
        chartPreprocessing(){
            const elementId = this.idChart;
            let chart = document.getElementById(elementId)
            const series = this.createDataSerie(this.volumeData);
            this.noData = false;
            if(this.volumeData.length == 0) {
                this.noData = true;
                return;
            }
            if(series){
                this.noData = false;
                this.charts(elementId, series )
                this.loading = false
                chart.style.visibility = 'visible'
                chart.style.display = 'block'
            } else {
                chart.style.visibility = 'hidden'
                chart.style.display = 'none'
            }

            this.$emit('chartRenderComplete', this.chartRendered);
        },

      getPlotLineConfig(item, index) {
          const visualLine = {
              value: item.val,
              id: 'limiar-' + index,
              color: item.col,
              width: 2,
              zIndex: 5,
              dashStyle: 'Dash',
          };

          const sensorLine = {
              value: item.val,
              id: 'limiar-sensor-' + index,
              color: 'rgba(0,0,0,0)',
              width: 25,
              dashStyle: 'Solid',
              zIndex: 6,

              events: {
                  mouseover: function (e) {
                      const chart = this.axis.chart;
                      const event = chart.pointer.normalize(e);

                      if (this.customTooltip) {
                          this.customTooltip.destroy();
                      }

                      const yFixoDaLinha = this.axis.toPixels(item.val);

                      this.customTooltip = chart.renderer.label(
                          item.text + '<br/><span style="font-weight: normal; font-size: 10px; color: #cccccc">' + item.desc + '</span>',
                          event.chartX + 15,
                          yFixoDaLinha - 20
                      )
                      .css({
                          color: item.col,
                          fontSize: '12px',
                          fontWeight: 'bold',
                          pointerEvents: 'none'
                      })
                      .attr({
                          fill: 'rgba(0, 0, 0, 0.85)',
                          padding: 8,
                          r: 5,
                          zIndex: 999999
                      })
                      .add();
                  },

                  mousemove: function (e) {
                      const chart = this.axis.chart;
                      const event = chart.pointer.normalize(e);

                      if (this.customTooltip) {
                          const yFixoDaLinha = this.axis.toPixels(item.val);

                          this.customTooltip.attr({
                              x: event.chartX + 15,
                              y: yFixoDaLinha - 40
                          });
                      }
                  },

                  mouseout: function () {
                      if (this.customTooltip) {
                          this.customTooltip.destroy();
                          delete this.customTooltip;
                      }
                  }
              }
          };

          return [visualLine, sensorLine];
      },
        async charts(elementId, series){

            const commonLines = [
              { value: this.operationalMaxQuote, width: 3, color: '#00C4F0', zIndex: 1 },
              { value: this.operationalMinQuote, width: 3, color: '#6D3F8C', zIndex: 1 }
            ];

            const dynamicLines = this.activeThresholdsList.flatMap((item, index) => {
              return this.getPlotLineConfig(item, index);
            });

            Highcharts.setOptions({
                lang: {
                    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                }
            });
            if (this.periodDate) {
            this.chartRendered = Highcharts.chart(elementId, {
                colorAxis:{
                    gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
                },
                chart: {
                    inverted: false,
                    backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
                    height: 600
                },
                plotOptions:{
                    series: {
                      dataLabels: {
                        style: {
                          pointerEvents: 'none'
                        }
                      }
                    },
                    columnrange:{
                        borderWidth: 0,
                        grouping: true,
                        centerInCategory: true
                    },
                },
                exporting: {
                    enabled: false,
                    filename: `Volume - ${this.basin.text}`,
                    sourceWidth: 1000,

                    chartOptions:{
                        title: {
                            text: `Volume - ${this.basin.text}`,
                            style:{
                                color: '#FFFFFF'
                            }
                        },
                        subtitle: {
                            text: `Dados de ${this.formatDate(this.periodDate.period[0])} a ${this.formatDate(this.periodDate.period[1])}`,
                            style:{
                                color: '#FFFFFF'
                            },
                        },

                        xAxis: {
                            tickInterval: this.periodDate.type === 'Diário' ? 24*3600*1000 : 30*24*3600*1000
                        },
                    }
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: true,
                    href: 'http://www.simepar.br/',
                    text:'by: SIMEPAR',
                    style:{
                        color: '#FFFFFF'
                    }
                },
                legend: {
                  enabled: true,
                  itemStyle:{
                    color: '#FFFFFF',
                  },
                  itemHoverStyle: {
                    color: '#979797'
                  },
                },
                xAxis: {
                    accessibility:{
                        description: `De ${this.formatDate(this.periodDate.period[0])} a ${this.formatDate(this.periodDate.period[1])}`
                    },
                    tickColor: '#2D324F',
                    tickWidth: 2,
                    lineWidth: 2,
                    lineColor: '#2D324F',
                    type: 'datetime',
                    ordinal: false,
                    crosshair: {
                        enabled: true
                    },
                    labels:{
                        format: this.periodDate.type === 'Diário' ? '{value:%d/%m/%y}' : '{value:%b/%y}',
                        style:{
                            color: '#FFFFFF'
                        },
                        rotation: -45,
                    },
                },
                yAxis: {
                    maxPadding: 0.3,
                    endOnTick: false,
                    title: {
                      text: `Volume (${this.unitMeasurement ? this.unitMeasurement : 'hm³'})`,
                      style:{
                          color: '#FFFFFF'
                      }
                    },
                    accessibility:{
                        description: `Volume (${this.unitMeasurement ? this.unitMeasurement : 'hm³'})`,
                    },
                    labels:{
                        style:{
                            color: '#FFFFFF'
                        }
                    },
                    plotLines:[...commonLines, ...dynamicLines]
                },
                tooltip:{
                    shared: true,
                    split: true,
                    useHTML: true,
                    xDateFormat: this.periodDate.type === 'Diário' ? '%A, %d de %B de %Y' : '%B de %Y',
                    pointFormatter: function() {
                        const tooltipText = this.options.tooltipText ? this.options.tooltipText : this.series.name;
                        const unitMeasurement = this.series.userOptions.unitMeasurement ? this.series.userOptions.unitMeasurement : 'hm³';
                        let value = (this.options.lossOrGainValue != null) ? this.options.lossOrGainValue : this.high;

                        if(this.series.userOptions.unitMeasurement !== "%" && this.series.userOptions.valueDecimals) {
                            value = Number(value).toFixed(this.series.userOptions.valueDecimals);
                        }
                        else {
                            value = Number(value).toFixed(2);
                        }

                        let html = '';
                        if(this.options.dateLabel){
                            html += `
                                <strong>${this.options.dateLabel}<strong/>
                                <br>
                            `;
                        }

                        html += `<strong style="color:${this.options.color}">${tooltipText}</strong>: <strong>${value} ${unitMeasurement}<strong/>`;

                        return html;
                    },
                },
                series:[
                  ...series,
                ],
                caption: {
                    text:`Gráfico de variação do volume com dados medidos em (${this.unitMeasurement ? this.unitMeasurement : 'hm³'}) de ${this.formatDate(this.periodDate.period[0])} até ${this.formatDate(this.periodDate.period[1])}`,
                    style: { color: '#FFFFFF'},
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });
            }
        },

        createDataSerie(rawData){
            const dataCurrentPeriod = [];
            const dataGainCurrentPeriod = [];
            const dataLossCurrentPeriod = [];
            const vm = this;
            for(const key in rawData){
                const dataItemCurrentPeriod = {
                  low: 0,
                  high: rawData[key].valor,
                  color: 'rgba(132, 166, 254, 0.83)',
                  x: new Date(rawData[key].data).getTime(),
                };
                dataCurrentPeriod.push(dataItemCurrentPeriod);
                if(key < rawData.length - 1){
                    const afterKey = Number(key)+1;
                    const difference = rawData[afterKey].valor - rawData[key].valor;
                    let color;
                    let tooltipText;
                    const LossGaindataItem = {
                        low: rawData[key].valor,
                        high: rawData[afterKey].valor,
                        x: new Date(rawData[afterKey].data).getTime(),
                        lossOrGainValue: Math.abs(difference),
                    };
                    if(difference >= 0){
                        color = this.$vuetify.theme.themes.dark.green.base;
                        tooltipText = `ganho de volume`;
                        dataGainCurrentPeriod.push({...LossGaindataItem, color, tooltipText});
                    }else{
                        color = this.$vuetify.theme.themes.dark.red.base;
                        tooltipText = `perda de volume`;
                        dataLossCurrentPeriod.push({...LossGaindataItem, color, tooltipText});
                    }
                }
            }
            return [
                {
                    type: 'columnrange',
                    name: 'ganho de volume',
                    data: dataGainCurrentPeriod,
                    color:this.$vuetify.theme.themes.dark.green.base,
                    unitMeasurement: this.unitMeasurement,
                    valueDecimals: 3
                },
                {
                    type: 'columnrange',
                    name: 'perda de volume',
                    data: dataLossCurrentPeriod,
                    color:this.$vuetify.theme.themes.dark.red.base,
                    unitMeasurement: this.unitMeasurement,
                    valueDecimals: 3
                },
                 {
                    type: 'columnrange',
                    name: 'volume',
                    data: dataCurrentPeriod,
                    unitMeasurement: this.unitMeasurement,
                    valueDecimals: 3
                },
                {
                    name: 'limiares',
                    dashStyle: 'Dash',
                    lineWidth: 2,
                    marker: { enabled: false },
                    data: [],
                    showInLegend: true,
                    enableMouseTracking: false,
                    custom: {
                      thresholds: this.activeThresholdsList,
                    },
                    events: {
                      legendItemClick: function () {
                        const yAxis = this.chart.yAxis[0];
                        const storedThresholds = this.options.custom.thresholds || [];

                        if (this.visible) {
                          storedThresholds.forEach((item, index) => {
                            yAxis.removePlotLine('limiar-' + index);
                            yAxis.removePlotLine('limiar-sensor-' + index);
                          });
                        } else {
                            storedThresholds.forEach((item,index) => {
                              const linhas = vm.getPlotLineConfig(item, index);

                              linhas.forEach(linha => {
                                yAxis.addPlotLine(linha);
                              });
                            });
                        }

                        return true;
                      },
                    }
                }
            ];
        },

        formatDate(date){
            const stringFormat = this.periodDate.type === 'Diário' ? 'DD/MM/YYYY' : 'MMMM YYYY';
            return moment(date).locale('pt-br').format(stringFormat).toUpperCase();
        }
    }
}
</script>

<style>

.btn-legend {
    margin-bottom: 10px;
    padding: 5px 10px;
    background-color: #2B3445;
    color: white;
    border: 1px solid #666;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    left: 0;
}
.btn-legend:hover {
    background-color: #7b86c1;
}
</style>
